export const AGE_CONSENT_KEY = 'ageConsent';
export const AI_INTERACTION_CONSENT_KEY = 'aiInteractionConsent';
export const USE_COOKIES_CONSENT_KEY = 'useCookiesConsent';
export const PRIVACY_POLICY_URL = '/assets/documents/Privacy_Policy.pdf';
